import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// Crear Secuenciales comprobantes electronicos User
const NewSecuencialesUser = Loadable(lazy(() => import('views/user/FacturacionView/ComprobantesElectronicosView/SecuencialesView/NewSecuencialesView')));

// Listar Secuenciales comprobantes electronicos User
const ListSecuencialesUser = Loadable(lazy(() => import('views/user/FacturacionView/ComprobantesElectronicosView/SecuencialesView/ListSecuencialesView')));

const ComprobantesRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/user/new-secuenciales/:id_secuenciales',
            element: <NewSecuencialesUser />
        },
        {
            path: '/user/list-secuenciales-view',
            element: <ListSecuencialesUser />
        }
    ]
};

export default ComprobantesRoutes;